import React from 'react';
import {HomepageSection, HomepageSectionHeader2} from '../Homepage';
import CountUp from 'react-countup';
import { process_country } from '../helper';


class PatientStatistics extends React.Component {
  render() {
    const stat = this.props.data;
    const patientNo = {
      ...stat,
      verified: stat.total - stat.not_yet_verified,
      only_old: 3228
    };

    const extData = process_country('stats');
    const total = stat.total + extData.total;
    const not_verified = stat.not_yet_verified + extData.not_yet_verified;
    const verified = total-not_verified;

    return (
      <HomepageSection>
        <HomepageSectionHeader2>
          <h2><span>{'Welcome to the ESID Registry Network Reporting Tool public webpage! '}</span></h2>
          <h5><span>{'The data shown is collected via the central ESID system, UKPID registry (UK) and IPINET (ITALY)'}</span></h5>
        </HomepageSectionHeader2>
        <div className='text-center' style={{marginTop: 60}}>
          <p>We are happy</p>
          <p>to count <CountUp className="no-of-patients"
                               start={0} end={total} suffix=" new registry's patients"/>.</p>
          <p>of these <CountUp className="no-of-patients"
                             start={0} end={not_verified} suffix=" patients"/> need to be verified.</p>
          <br />
          <br />
          <p>
            The following figures show numbers based on <CountUp className="no-of-patients"
                                                                 start={0} end={verified}
                                                                 suffix=" verified patients"/> of the new registry.
          </p>
          <p>
            Database from: {this.props.lastUpdated}.
          </p>
        </div>
      </HomepageSection>
    );
  }
}

export default PatientStatistics;



// WEBPACK FOOTER //
// ./src/views/Pages/Homepage/Sections/PatientStatistics.js